$(function () {

  const $window = $(window);

  function setHamburger() {
    const $hamburgerBtn = $('.js-hamburger-btn');
    const $hamburgerContent = $('.js-hamburger-content');
    let windowScrollTop;

    $hamburgerBtn.on('click', function() {
      const $this = $(this);

      const isOpen = $this.hasClass('is-open');
      if (isOpen) {
        $('body').removeClass('is-fixed').css({'top': ''});
        $window.scrollTop(windowScrollTop);
        $this.removeClass('is-open');
        $hamburgerContent.stop().slideUp(500);
      } else {
        windowScrollTop = $window.scrollTop();
        $('body').addClass('is-fixed').css({'top': -windowScrollTop});
        $this.addClass('is-open');
        $hamburgerContent.stop().slideDown(500);
      }
    });

    const $peopleIcon = $('.nav-subMenu__btn--peopleIcon');

    $peopleIcon.on('click', function() {
      $('.toggle-wrapper').slideToggle(200);
    });

  }

  function setCategoryNav() {
    const $btn = $('.js-categorySP-btn');
    const $content = $('.js-categorySP-content');
    let windowScrollTop;

    $btn.on('click', function() {
      const $this = $(this);

      const isOpen = $this.hasClass('is-open');
      if (isOpen) {
        // $('body').removeClass('is-fixed').css({'top': ''});
        $window.scrollTop(windowScrollTop);
        $this.removeClass('is-open');
        $content.stop().slideUp(500);
      } else {
        windowScrollTop = $window.scrollTop();
        // $('body').addClass('is-fixed').css({'top': -windowScrollTop});
        $this.addClass('is-open');
        $content.stop().slideDown(500);
      }
    });
  }

  function setDropdown() {
    const $dropdown = $('.js-dropdown');
    const $dropdownBtn = $('.js-dropdown-btn');
    const $dropdownContent = $('.js-dropdown-content');

    $dropdownBtn.on('click', function() {
      const $this = $(this);

      const isSP = $window.width() < 768;
      if (isSP) {
        const isOpen = $this.hasClass('is-open');
        if (isOpen) {
          $this.removeClass('is-open');
          $this.next($dropdownContent).stop().slideUp(500);
        } else {
          $this.addClass('is-open');
          $this.next($dropdownContent).stop().slideDown(500);
        }
      } else {
        return false;
      }
    });

    $dropdownBtn.on('mouseenter', function() {
      const $this = $(this);

      const isPC = $window.width() > 767;
      if (isPC) {
        $this.find($dropdownBtn).addClass('is-open');
        $dropdownContent.stop(true,true).slideDown(500);
      } else {
        return false;
      }
    })

    $dropdown.on('mouseleave', function() {
      const $this = $(this);

      const isPC = $window.width() > 767;
      if (isPC) {
        $this.find($dropdownBtn).removeClass('is-open');
        $dropdownContent.stop(false,true).slideUp(500);
      } else {
        return false;
      }
    });
  }

  function smoothScroll() {
    const headerHightSp = 50; //ヘッダの高さsp
    const headerHightPc = 63; //ヘッダの高さpc
    $('a[href^="#"]').click(function () {
      const href = $(this).attr("href");
      const target = $(href == "#" || href == "" ? 'html' : href);
      let position;
      if(".js-scrollStatic") {
        const isPC = $window.width() > 768;
        if(isPC) {
          position = target.offset().top-headerHightPc;
        } else {
          position = target.offset().top-headerHightSp;
        }
      } else {
        position = target.offset().top;
      }
      $('html, body').animate({scrollTop: position}, 500);
        return false;
    });
  }
  
  $(function() {
    const toTopIcon = $("#ToTopIcon");
    toTopIcon.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 10) {
        toTopIcon.fadeIn("fast");
      } else {
        toTopIcon.fadeOut("fast");
      }
      const scrollHeight = $(document).height(); 
      const scrollPosition = $(window).height() + $(window).scrollTop(); 
      const footHeight = $("footer").innerHeight(); 
      const isPC = $window.width() > 768;
      if(isPC) {
        if ( scrollHeight - scrollPosition  <= footHeight ) { 
          $("body").addClass("bodyPosition");
          toTopIcon.css({"position":"absolute","bottom": footHeight - 30});
        } else { 
          $("body").removeClass("bodyPosition");
          toTopIcon.css({"position":"fixed", "bottom": "30px" });
        }
      } else {
        if ( scrollHeight - scrollPosition  <= footHeight ) { 
          $("body").addClass("bodyPosition");
          toTopIcon.css({"position":"absolute","bottom": footHeight - 17});
        } else { 
          $("body").removeClass("bodyPosition");
          toTopIcon.css({"position":"fixed", "bottom": "30px" });
        }
      }
    });
    toTopIcon.click(function () {
      $("body,html").animate({ scrollTop: 0 }, "fast");
      return false;
    });
  });

  const isIE = document.documentMode && document.uniqueID;
  if (isIE) {
    objectFitImages();
  }
  setCategoryNav();
  setHamburger();
  setDropdown();
  smoothScroll();

});